<p-tabs
  [value]="selectedOwner()!"
  (valueChange)="onTabChange($event)">
  <p-tablist>
    @for (owner of owners(); track owner) {
      <p-tab [value]="owner.slug">{{ owner.label }}</p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="selectedOwner()!">
      <app-warehouse-product-list
        [owner]="selectedOwner()!"
        [downloadQuantityReportVisibility]="
          downloadQuantityReportVisibility()
        " />
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
